import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiMessageCircle, FiCheckCircle } = FiIcons;

const ContactQA = () => {
  const affiliateLink = "https://learn.augustapreciousmetals.com/apm-aff-lp-1-v3?apmtrkr_cid=1696&aff_id=5283&sub_id=YOUR_IDENTIFIER";

  return (
    <section id="ask-question" className="py-20 bg-slate-900 text-white z-10 relative">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-800 p-8 md:p-12 rounded-3xl border border-slate-700 shadow-2xl text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl -z-10 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -z-10 pointer-events-none"></div>
          <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-400/10 rounded-full mb-6 ring-4 ring-yellow-400/5">
            <SafeIcon icon={FiMessageCircle} className="text-yellow-400 text-3xl" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 italic text-white">Have a Specific Question?</h2>
          <p className="text-slate-100 text-lg md:text-xl mb-12 max-w-3xl mx-auto leading-relaxed"> Connect directly with our top-rated Gold IRA partner. Request your free guide today and gain access to a complimentary 1-on-1 educational web conference with an <strong className="text-yellow-400">on-staff Harvard-trained economic analyst</strong>. </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 text-left max-w-4xl mx-auto">
            <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700/50 backdrop-blur-sm">
              <SafeIcon icon={FiCheckCircle} className="text-yellow-400 text-2xl mb-4" />
              <h4 className="font-bold text-white mb-2 text-lg">Zero Pressure</h4>
              <p className="text-sm text-slate-200">Education-first approach. No aggressive sales tactics.</p>
            </div>
            <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700/50 backdrop-blur-sm">
              <SafeIcon icon={FiCheckCircle} className="text-yellow-400 text-2xl mb-4" />
              <h4 className="font-bold text-white mb-2 text-lg">Expert Guidance</h4>
              <p className="text-sm text-slate-200">Get answers about rollovers and secure storage.</p>
            </div>
            <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700/50 backdrop-blur-sm">
              <SafeIcon icon={FiCheckCircle} className="text-yellow-400 text-2xl mb-4" />
              <h4 className="font-bold text-white mb-2 text-lg">Full Support</h4>
              <p className="text-sm text-slate-200">95% of the transfer paperwork is handled for you.</p>
            </div>
          </div>
          <a href={affiliateLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-slate-900 transition-all duration-300 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl shadow-lg hover:-translate-y-1 w-full sm:w-auto group" > Get Free Guide & Speak to an Expert <SafeIcon icon={FiArrowRight} className="ml-3 group-hover:translate-x-1 transition-transform" /> </a>
        </div>
      </div>
    </section>
  );
};

export default ContactQA;